import * as React from "react";
import { getDiffMinutes, getTimes } from "../utils";
import styled from "styled-components";
import { Strings } from '--root/strings/en';
import VirtualScroll from "./VirtualScroll";

const STRINGS = Strings.dateTime;

type tInterval = 1|5|10|15|20|30|60;
type tFormat = 12|24;
type TimeSidebarProps = {
    interval: tInterval
    format: tFormat
    min: Date
    max: Date
    onClick?: (date: Date)=>void
    active?: Date
    style?: React.CSSProperties
}

const getActiveIndex = (min: Date, interval: number, active?:Date) => {
    const minDiff = getDiffMinutes(min, active || new Date());
    return Math.floor(minDiff/interval);
}

const TimeSidebar: React.FC<TimeSidebarProps> = props => {
    const { min, max, interval, format, active, onClick, style } = props;
     
    const timesHeight = 32;
    const times = getTimes(min, max, interval);
    const activeIndex = getActiveIndex(min, interval, active);
    const scrollTop = activeIndex * timesHeight;
    
    return <StyledTimeSidebar>
        <VirtualScroll
            items={times}
            itemHeight={timesHeight}
            renderer={(time, idx) => <Label time={time as Date} format={format} interval={interval} active={idx==activeIndex} onClick={onClick} />}
            scrollTop={scrollTop}
            center
            style={style} />
    </StyledTimeSidebar>
};
const StyledTimeSidebar = styled.div`
    height: 100%;
    position: relative;
    border-left: 1px solid ${props => props.theme.palette.ui.border};
`;

type LabelProps = {
    format: tFormat
    interval: tInterval
    time: Date
    active?: boolean
    onClick?: (date: Date) => void
}
const Label: React.FC<LabelProps> = (props) => {
    const {time, format, interval, active, onClick} = props;

    let hh = format == 24 ? 
        ("0" + time.getHours()).substr(-2) :
        (time.getHours() % 12).toString();
    if (hh == "0") hh = "12";
    const mm = ("0" + time.getMinutes()).substr(-2);
    const pm = time.getHours() >= 12;
    const major = mm == "00" && interval <= 15;
    
    return <StyledLabel onClick={() => onClick && onClick(time)} major={major} active={active}>
        <span>{hh}</span>
        <span>:</span>
        <span>{mm}</span>
        {format == 12 && <span>{pm ? STRINGS.pm : STRINGS.am}</span>}
    </StyledLabel>
}
type StyledLabelProps = {
    major?: boolean
    active?: boolean
}
const StyledLabel = styled.div<StyledLabelProps>`
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    ${props => props.theme.typography.body2};
    font-weight: ${props => (props.major || props.active) ? props.theme.typography.bold : 'initial'};
    color: ${props => (props.major || props.active) ? props.theme.palette.text.primary : props.theme.palette.text.secondary};
    margin: 0;
    display: flex;
    align-items: center;
    padding: ${props => props.theme.spacing(0, 1)};
    background: ${props => props.active ? props.theme.palette.ui.highlight : "initial"};
    border-radius: ${props => `0 ${props.theme.radius.small} ${props.theme.radius.small} 0`};
    cursor: ${props => props.onClick ? "pointer" : "initial"};

    &>span:nth-child(1) {
        display: inline-block;
        width: 20px;
        text-align: right;
    }
    &>span:nth-child(2) {
        display: inline-block;
        padding: 0 0.12em;
    }
    &>span:nth-child(3) {
        display: inline-block;
        width: 20px;
        text-align: left;
    }
    &>span:nth-child(4) {
        ${props => props.theme.typography.body3};
        display: inline-block;
        margin: 0;
    }
`;

export default TimeSidebar;
export { TimeSidebar, TimeSidebarProps, tInterval, tFormat };
